import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { InventoryType } from '../../models/inventory/inventory-type';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class InventoryTypeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/inventory-type';

  public getAllInventoryType(): Observable<ApiResponse<InventoryType[]>> {
    return this.httpClient.get<ApiResponse<InventoryType[]>>(`${this.baseUrl}/all`);
  }
}
